import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import HierTable from '../../HierTable';
import Spinner from '../../Spinner';

@inject("ratingEquationStore", 'stationStore', 'parameterStore', 'rolePermissionStore')
@observer
class RTEquationList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.shape().isRequired,
  };

  handleDelete = (idOrIds) => {
    this.props.ratingEquationStore.removeItems(idOrIds);
  }

  slug = 'hydrology/rt_equations/list';
  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'station.name', label: 'Station' },
    { key: 'start_time', label: 'Start Time' },
    { key: 'end_time', label: 'End Time' },
    { key: 'stage_from', label: 'Stage From' },
    { key: 'stage_to', label: 'Stage To' },
    { key: 'stage', label: 'Stage' },
    { key: 'discharge', label: 'Discharge' },
    { key: 'remarks', label: 'Remarks' },
    { key: 'status', label: 'Status' },
  ];

  flattenItems(dataArray) {
    const data = dataArray || [];

    const arr = [];

    data.forEach(item => {
      arr.push({
        type: 'CURVE',
        level: 1,
        key: item.id,
        slug: this.slug,
        childSlug: `hydrology/rt_equations/${item.id}/equation`,

        id: item.id,
        name: item.name,
        description: item.description,
        station: item.station,
        start_time: item.start_time,
        end_time: item.end_time,
        remarks: item.remarks,
        status: item.status,
        stage: item.stage,
        discharge: item.discharge,
      });

      if (item.equations) {
        item.equations.sort((a, b) => +a.id < +b.id ? -1 : 1).forEach(equation => {
          arr.push({
            type: 'EQUATION',
            level: 2,
            key: `curve-${item.id}_equation-${equation.id}`,
            slug: `hydrology/rt_equations/${item.id}/equation`,
            parent_id: item.id,

            id: equation.id,
            stage_from: equation.stage_from,
            stage_to: equation.stage_to,
          });
        });
      }
    });
    return arr;
  }

  handleDelete = (id, type, parent_id) => {
    const { ratingEquationStore } = this.props;
    const { notify } = this.context;

    let remove = () => (type === 'CURVE' ? ratingEquationStore.removeItems(id) : ratingEquationStore.removeEquation(parent_id, id));
    remove().then(() => {
      this.forceUpdate();
      notify.success({ message: 'Success' });
    }).catch(err => {
      notify.error(err);
    });
  }

  render() {
    const { ratingEquationStore, stationStore, parameterStore, rolePermissionStore, children } = this.props;

    if (ratingEquationStore.isLoading || stationStore.isLoading || parameterStore.isLoading) return <Spinner />;

    let data = ratingEquationStore.items.map(item => (Object.assign({}, item, {
      station: stationStore.findById(item.station_id),
      status: <i className='fa fa-circle' style={{ color: item.status ? 'green' : 'red' }} data-toggle="tooltip" title={item.status ? 'Enabled' : 'Disabled'} />,
      stage: item.stage ? parameterStore.findById(item.stage).name : '',
      discharge: item.discharge ? parameterStore.findById(item.discharge).name : '',
    })));

    const canModifyHydrology = rolePermissionStore.validateRole('modify hydrology');

    return (
      <div>
        <HierTable
          data={this.flattenItems(data)}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resources={{ parent: 'hydrology', child: 'hydrology' }}
          actions={!canModifyHydrology ? [
            { label: 'View', link: '/hydrology/rt_equations/{parent_id}/equation/{id}', level: 2 },
          ] : []}
        />
        {children}
      </div>
    );
  }
}

export default RTEquationList;



// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RTEquationList.js